import { ProviderType } from "components/integrations/managed_integrations/types";
import { CreateManagedSyncMutationVariables } from "lib/generated/app-service-gql/graphql";

type GoogleDocType = "document" | "folder";

type GoogleDoc = {
  id: string;
  serviceId: string;
  mimeType: string;
  name: string;
  description: string;
  type: GoogleDocType;
  lastEditedUtc: number;
  iconUrl: string;
  url: string;
  embedUrl: string;
  driveSuccess: boolean;
  sizeBytes: number;
  parentId: string;
};

interface GoogleFilesResult {
  docs: GoogleDoc[];
}

interface SharePointIds {
  listId: string;
  webId: string;
  siteId: string;
}

interface SharePointParentReference {
  driveId: string;
  sharepointIds: SharePointIds;
}

interface SharePointSelfReference extends SharePointIds {
  listItemId: string;
  listItemUniqueId: string;
}

interface SharePointFile {
  id: string;
  parentReference: SharePointParentReference;
  sharepointIds: SharePointSelfReference;
}

type SharePointFilesResult = SharePointFile[];

export default function buildCreateSyncOptionsFromFiles(
  provider: ProviderType,
  files: unknown,
): CreateManagedSyncMutationVariables {
  switch (provider) {
    case "googledrive": {
      // TODO: Add zod
      const googleFiles = files as GoogleFilesResult;

      return {
        req: {
          integration: provider,
          files: googleFiles.docs.map(({ id, type }) => ({ id, type })),
        },
      };
    }

    case "sharepoint": {
      // TODO: Add zod
      const spFiles = files as SharePointFilesResult;

      return {
        req: {
          integration: provider,
          files: spFiles.map(({ id, sharepointIds, parentReference }) => ({
            id,
            listId: sharepointIds.listId,
            listItemId: sharepointIds.listItemId,
            driveId: parentReference.driveId,
          })),
        },
      };
    }

    default:
      throw new Error(`Unsupported cms provider: ${provider}`);
  }
}
